import request from '@/utils/request-common'

export function getIcubeMap() {
  return request({
    url: '/common/iCubeMap',
    method: 'get'
  })
}
